import { usePlanejamentoControle } from "./use-planejamento-controle";
import { PlanejamentoControleView } from "./view-planejamento-controle";
import type { PlanejamentoControleProps } from "./types-planejamento-controle";

export function PlanejamentoControle(props: PlanejamentoControleProps) {
  const vm = usePlanejamentoControle(props);

  return <PlanejamentoControleView {...vm} />;
}

export type * from "./types-planejamento-controle";
